angular.module('app.auth').factory('app.auth.interception', [
    'util', '$q', '$injector', '$location', '$localStorage', 'config', '$sessionStorage', function (util, $q, $injector, $location, storage, appConfig, session) {

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
        }

        function request(config) {
            config.headers = config.headers || {};
            if(!config.cdi) {
                config.headers['Ocp-Apim-Subscription-Key'] = appConfig.settings.apiKey;
                config.headers['Session'] = (session.session = session.session || guid());
            }

            return config;
        }

        function responseError(rejection) {
            if (rejection.status === 401 || rejection.status === 403) {
                var authService = $injector.get('app.auth.service');
                authService.signOut();
                if (rejection.status === 401) {
                    window.location = '/#/sign-in';
                } else {
                    window.location = '/#/unauthorized';
                }
            }
            return $q.reject(rejection);
        }

        return {
            request: request,
            responseError: responseError
        };
    }
]).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('app.auth.interception');
    $httpProvider.defaults.withCredentials = true;
}]);
